// export default function ErrorModal({ open, message, onClose }) {
//     if (!open) return null;

//     return (
//         <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//             <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6">

//                 {/* Header */}
//                 <div className="flex justify-between items-center mb-4">
//                     <h2 className="text-lg font-semibold text-red-600">Out of Stock</h2>
//                     <button
//                         onClick={onClose}
//                         className="text-gray-500 hover:text-gray-700"
//                     >
//                         ✕
//                     </button>
//                 </div>

//                 {/* Message */}
//                 <p className="text-gray-700 leading-relaxed whitespace-pre-line">
//                     {message}
//                 </p>

//                 {/* Footer */}
//                 <div className="mt-6 text-right">
//                     <button
//                         onClick={onClose}
//                         className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
//                     >
//                         OK
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }




export default function ErrorModal({ open, message, onClose }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6">

                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-black">Out of Stock</h2>
                    <button
                        onClick={onClose}
                        className="text-black hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>

                {/* Message */}
                <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                    {message}
                </p>

                {/* Footer */}
                <div className="mt-6 text-right">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
}

